import { observer } from 'mobx-react';
import { ProfileType } from '@ixicare/resources';
import { FirmwareList } from '~/modules/firmware';
import { usePageTitle } from '~components/DashboardWrapper/PageTitle';
import ErrorPage from '~/pages/ErrorPage';
import { useStores } from '~store/utils';
import { t } from '~/i18n';

const FirmwareListPage = observer(() => {
  const { auth, permissions } = useStores();
  usePageTitle(t('menu.dashboard.firmware'));

  if (auth.userType !== ProfileType.WatcherrEmployee || !permissions.has('can_manage_firmware')) {
    return <ErrorPage statusCode={404} />;
  }
  return <FirmwareList />;
});

export default FirmwareListPage;
